import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useDisclosure } from "../../hooks/useDiclosure";


export type ConfirmationDialogProps = {
    triggerButton: React.ReactElement;
    confirmButton: React.ReactElement;
    title: string;
    body?: string;
    cancelButtonText?: string;
    isDone?: boolean;
};

export const ConfirmationDialog = ({
    title,
    body = '',
    triggerButton,
    confirmButton,
    cancelButtonText = 'Cancel',
    isDone = false,
  }: ConfirmationDialogProps) => {

    const { close, open, isOpen } = useDisclosure();

    React.useEffect(() => {
        if (isDone) {
          close();
        }
    }, [isDone, close]);

    const onClick = (e:any) => {
        e.stopPropagation();
        open();
    }
    
    const trigger = React.cloneElement(triggerButton, {
        onClick: onClick,
    });

    return (
        <>
            {trigger}
            <Modal 
                show={isOpen}
                onHide={close}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                
                {body && (
                    <Modal.Body>{body}</Modal.Body>
                )}
                <Modal.Footer>
                    {confirmButton}
                    <Button variant="secondary" onClick={close}>
                        {cancelButtonText}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};